<template>
  <div class="container">
    <div class="columns">
      <div class="column card is-offset-3 is-6 content">
        <div class="section">
          <h3 class="has-text-centered">
            Administrative access
          </h3>
          <p v-html="$wording.admin_login.city_login" />
          <p class="has-text-centered m-t-lg">
            <button
              class="button citylogin-button is-primary"
              :class="{ 'is-loading': loginIn }"
              :disabled="loginIn"
              @click="doLogin"
            >
              City login
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ADLogin',
  data() {
    return {
      loginIn: false,
    };
  },
  created() {
    this.$store.commit('login/initMsal');
  },
  methods: {
    async doLogin() {
      this.loginIn = true;
      const accessToken = await this.$store.dispatch('login/adminGetToken');
      console.log("Did we get a token?", accessToken);
      if (accessToken) {
        this.$store.dispatch('login/vulcanAuthentication', accessToken);
      } else {
        this.$warning("It seems that you don't have access. Please verify your internet access and that you entered the correct City Account.\nIf the problem persists contact the system administrators; you likely need to be added to the Active Directory Group for this application.");
      }
      this.loginIn = false;
    },
  },
};
</script>